module.exports = "function setup() {\r\n  createCanvas(100, 100);\r\n}\r\n\r\nfunction draw() {\r\n  background(255, 0, 200);\r\n}\r\n"


/*****************
 ** WEBPACK FOOTER
 ** ./~/raw-loader!./lib/default-sketch.js
 ** module id = 181
 ** module chunks = 0
 **/